<template>
    <div class="login clearfix flex">
      <div class="login-left">
        <img src="../../assets/images/login/logon-right.png" alt="">
      </div>
      <div class="login-right">
        <div class="login-right-logo"><img src="../../assets/images/login/logo.png" alt=""></div>
        <div class="login-right-content flexColumn">
          <img class="login-right-content-titleimg" src="../../assets/images/login/title.png" alt="图片">
          <p class="login-right-content-title">验证码登录/注册</p>
          <p class="login-right-content-subtitle">首次验证通过即注册蓉e聘-C端账号</p>
          <div class="login-right-content-borders"></div>

          <div class="login-right-content-tabs flex">
            <p class="active">我要找工作</p>
            <p class="" @click="openPublishPositionWeb">我要招聘</p>
          </div>
         
          <div class="login-form" v-if="activeName=='sms'">
                <el-form
                  :model="form"
                  :rules="loginRules"
                  ref="loginform"
                  class="login-form-wraper"
                  status-icon
                >
                  <el-form-item prop="username" >
                    <div class="flex login-form-item" >
                    <p >+86</p>
                    <el-input v-model="form.username" placeholder="请输入手机号码">
                    </el-input>
                </div>
                  </el-form-item>
                  <el-form-item prop="smscaptcha">
                    <div class="flex login-form-item" style="padding-right: 16px;"> 
                        <el-input v-model="form.smscaptcha" type="text" placeholder="请输入手机验证码">
                    </el-input>
                    <el-button
                        class="getcodes"
                          type="text"
                          @click="sendVcodeAction"
                          :loading="vcodeSending"
                        >
                          <i v-if="this.s > 0">{{ this.s }}s后重新发送短信</i>
                          <i v-else>{{
                            vcodeSending ? "正在获取验证码" : "获取验证码"
                          }}</i>
                        </el-button>

                    </div>
                    
                  </el-form-item>
                  <el-form-item  prop="imageCaptcha">
              <el-input v-model="form.imageCaptcha" placeholder="请输入图形验证码">
                <template slot="append">
                  <div class="captcha-wraper">
                    <img
                      :src="`${captcha + id}`"
                      alt="验证码"
                      @click="getNewCaptchaId"
                    />
                    <!-- <div class="captchaLoading" v-if="captchaLoading">
                      加载中...
                    </div> -->
                  </div>
                </template>
              </el-input>
            </el-form-item>


                  <el-button
                    type="primary"
                    class="login-submit-btn"
                    @click="loginAction"
                    :loading="loading"
                    @keyup.enter.native="loginAction"
                    >登录/注册
                  </el-button>
                   <p class="login-right-des">
              <el-checkbox v-model="checked">我已阅读并同意蓉e聘-C端
                <!-- <router-link tag="li" to="/index/privacy" >《隐私政策》</router-link> -->
                <a href="/index/userAgreement"
                  target="_blank"
                  @click="checked = true"> 《用户协议》</a>
                  <a href="/index/privacy"
                  target="_blank"
                  @click="checked = true">《隐私政策》</a>
              </el-checkbox>
            </p>
                </el-form>
          </div>
          <div v-else style="height: 312px;">
            <iframe
                src="https://open.weixin.qq.com/connect/qrconnect?appid=wx0e6d0828dc561eb1&redirect_uri=https://www.itneituiquan.com/wechatLogin&response_type=code&scope=snsapi_login&state=STATE"
                frameborder="0">
            </iframe>
          </div>

        <div class="login-type flex"  @click="handleLogin('sms')" v-if="activeName=='weixin'"> 
            <img src="../../assets/images/login/mail.png" alt=""> 短信登录
        </div>
        <div class="login-type flex"  @click="handleLogin('weixin')" v-else> 
            <img src="../../assets/images/login/weichat.png" alt=""> 微信登录
        </div>

          


          <!-- <el-tabs
            v-model="activeName"
            @tab-click="tabClick"
            :stretch="true"
            @keyup.enter.native="loginAction"
          >
            <el-tab-pane label="密码登录" name="password">
              <div class="login-form" v-if="activeName == 'password'">
                <el-form
                  :model="form"
                  :rules="loginRules"
                  ref="loginform"
                  label-width="68px"
                  class="login-form-wraper"
                  label-position="left"
                  status-icon
                >
                  <el-form-item label="用户名" prop="username">
                    <el-input v-model="form.username"></el-input>
                  </el-form-item>
                  <el-form-item label="密码" prop="password">
                    <el-input v-model="form.password" type="password"></el-input>
                  </el-form-item>
                  <el-form-item label="验证码" prop="captcha">
                    <el-input v-model="form.captcha">
                      <template slot="append">
                        <div class="captcha-wraper">
                          <img
                            :src="`${captcha + id}`"
                            alt="验证码"
                            @click="getNewCaptchaId"
                          />
                          <div class="captchaLoading" v-if="captchaLoading">
                            加载中...
                          </div>
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                  <el-button
                    type="primary"
                    class="login-submit-btn"
                    @click="loginAction"
                    :loading="loading"
                    >登录
                  </el-button>
                  <p class="register-form-des">
                    没有账号，去<router-link tag="a" to="/register"
                      >注册</router-link
                    >
                  </p>
                </el-form>
              </div>
            </el-tab-pane>
            <el-tab-pane label="短信登录" name="sms">
              
            </el-tab-pane>
            <el-tab-pane label="微信登录" name="weixin">
              <iframe
                src="https://open.weixin.qq.com/connect/qrconnect?appid=wx0e6d0828dc561eb1&redirect_uri=https://www.itneituiquan.com/wechatLogin&response_type=code&scope=snsapi_login&state=STATE"
                frameborder="0"
              ></iframe>
            </el-tab-pane>
          </el-tabs> -->
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions, mapState } from "vuex";
  import { base64 } from "../../libs/utilts";
  import { getLoadings } from "../../libs/vuex-loading/index";
  import { regular } from "../../libs/utilts";
  export default {
    name: "login",
    data() {
      return {
        id: "",
        captchaLoading: false,
        s: 0,
        timer: null,
        form: {
          userType: "SEEKER",
          username: "",
        //   password: "",
          captcha: "",
          smscaptcha: "" ,// 短信验证码
          imageCaptcha:""
        },
        logining: false,
        activeName: "sms",
        captchaCheck: true,
        checked:false,
        loginType:'sms',
      };
    },
    created() {
      this.getNewCaptchaId();
    },
    computed: {
      ...getLoadings(loadings => ({
        loading: loadings.action("login"),
        vcodeSending: loadings.action("sendVcode")
      })),
      ...mapState({
        captcha: state => state.user.captcha
      }),
      loginRules() {
        const phoneReg = regular.phone;
        // 验证手机号码
        const validatorPhone = async (rule, value, callback) => {
          let phoneEx = false;
          // if (value && phoneReg.test(value)) {
          //   phoneEx = await this.checkMobile(value);
          // }
          if (!value) {
            return callback(new Error("手机号不能为空"));
          }
          if (!phoneReg.test(value)) {
            return callback(new Error("请输入有效手机号"));
          } 
          // else if (!phoneEx.data) {
          //   return callback(new Error("此用户不存在"));
          // } 
          else {
            callback();
          }
        };
        // 验证验证码
        const validatorCaptcha = async (rule, value, callback) => {
          if (!value) {
            return callback(new Error("请输入验证码"));
          } else {
            if (!this.captchaCheck) {
              return callback(new Error("验证码错误"));
            } else {
              callback();
            }
          }
        };
        return {
          username: [
            { required: true, trigger: "change", validator: validatorPhone }
          ],
          //password: [{ required: true, message: "请输入密码", trigger: "blur" }],
          captcha: [
            { required: true, trigger: "change", validator: validatorCaptcha }
          ],
          smscaptcha: [
            { required: true, message: "请输入短信验证码", trigger: "blur" }
          ],
          imageCaptcha: [
            { required: true, message: "请输入图形验证码", trigger: "blur" }
          ],
          
        };
      }
    },
    methods: {
      ...mapActions(["login", "checkMobile", "getInitDate", "sendVcode"]),
      tabClick() {},
      getNewCaptchaId() {
        this.captchaLoading = true;
        this.id = Math.random();
        // 模拟一个loading
        setTimeout(() => {
          this.captchaLoading = false;
        }, 1500);
      },
      async loginAction() {
        
        this.captchaCheck = true;
        if (!(await this.$refs.loginform.validate())) return;
        if(!this.checked){return this.$message.warning("请先同意用户协议及隐私政策！");}
        const username = this.form.username;
        //const password = base64(`${username}:${this.form.password}`);
        const userType = this.form.userType;
        const captchaHashing = this.id;
        const captcha = this.form.captcha;
        const grantType = this.activeName;
        let sendData = {
          username: this.form.username,
          //password,
          userType,
          captcha,
          grantType,
          captchaHashing
        };
        if (this.activeName == "sms") {
          sendData = {
            mobile: this.form.username,
            captcha: this.form.smscaptcha,
            userType,
            grantType
          };
        }
        const res = await this.login(sendData);
        if (res.data) {
          window.localStorage.setItem("token", res.data.accessToken);
          await this.getInitDate();
          this.$router.replace("/");
        } else {
          if (res.code == 99010) {
            this.captchaCheck = false;
           // this.$refs["loginform"].validate();
          } else {
          }
          this.$message.error(res.message);
        }
      },
      async sendVcodeAction() {
        if (this.s > 0) return ;
        const captchaHashing = this.id;
        const captcha = this.form.captcha;
        const mobile = this.form.username;
        // const phoneEx = await this.checkMobile(mobile);
        // if (!phoneEx.data) return this.$message.error("账号不存在");
        const { data, message } = await this.sendVcode({
          captcha,
          captchaHashing,
          mobile,
          smsTemplateType: "LOGIN"
        });
        if (data) {
          this.$message.success("验证码发送成功，请注意查收!");
          this.s = 60;
          this.timer = setInterval(() => {
            this.s--;
            if (this.s === 0) {
              clearInterval(this.timer);
            }
          }, 1000);
        } else {
          this.$message.error(message);
        }
      },
      handleLogin(type){
        this.activeName  = type
      },
      openPublishPositionWeb(){
            window.open("https://www.selfhelp.itneituiquan.com", "_self");
        }
    },
    destroyed() {
      clearInterval(this.timer);
    },
    
  };
  </script>
  
  <style lang="less" scoped>
  .login {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 1080px;
    height: 710px;
    background: #FFFFFF;
    box-shadow: 0px 8px 24px -4px rgba(32,100,196,0.6);
    border-radius: 24px;
    &-left{
        width: 520px;
        img{
            width: 520px;
        }
    }
    &-right {
        flex: 1;
        box-sizing: border-box;
        padding-top: 36px;
        &-logo{
           text-align: right;
           margin-right: 36px;
            img{
                width: 117px;
            }
        }
        &-content {
            padding: 0 90px;
            &-titleimg{
                width: 229px;
                line-height: 0;
                margin-bottom: -22px;
            }
            &-title{
                font-size: 28px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(0,0,0,0.88);
                line-height: 40px;
            }
            &-subtitle{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0,0,0,0.45);
                line-height: 20px;
            }
            &-tabs{
                width: 100%;
                height: 40px;
                background: #F1F5F9;
                border-radius: 28px;
                padding: 1px 0;
                margin-bottom: 30px;
                p{
                    width: 50%;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                    font-size: 18px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(0,0,0,0.55);
                }
                .active{
                    background: #FFFFFF;
                    box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
                    border-radius: 26px;
                    font-weight: 500;
                    color: #287CF3;

                }
            }
            &-borders{
                width: 50px;
                height: 6px;
                background: #287CF3;
                border-radius: 3px;
                margin: 36px 0 32px;
            }

        
            
            
           
            
            
        }
        &-des{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0,0,0,0.45);
            line-height: 20px;
            padding-top: 16px;

        }
    }
    &-form {
        width: 100%;
      &-item{
        height: 43px;
        background: #FFFFFF;
        border-radius: 6px;
        border: 1px solid #DADEE2;
        p{
            padding-left: 16px;
            display: inline-block;
            position: relative;
            padding-right: 20px;
            &::after{
              position: absolute;
              content: '';
              width: 1px;
              height: 28px;
              top: 7px;
              right: 0;
              background: #DADEE2;
            }

        }
       /deep/ .el-input__inner{
            border: none !important;
            
        }
        .getcodes{
            padding-left: 16px;
            position: relative;
            &::before{
              position: absolute;
              content: '';
              width: 1px;
              height: 28px;
              top: 7px;
              left:0;
              background: #DADEE2;
            }

        }
      }
      &-wraper {
        margin-top: 20px;
        .captcha-wraper{
          height: 38px;
          width: 120px;
          overflow: hidden;
          img{
            height: 38px;
            width: 120px;
            cursor: pointer;
          }
        }
        
      }
      .el-form-item {
        // border-bottom: 1px solid #ddd;
        &.is-error {
          border-color: red;
        }
        &.is-success {
          border-color: #67c23a;
        }
       
        .el-input-group__append {
          background: none;
          border: 0;
          padding: 0;
          cursor: pointer;
          .el-button--text {
            color: #1e88e5;
            width: 160px;
            span {
              border-left: 1px solid #ddd;
              padding-left: 20px;
            }
            i {
              font-style: normal;
            }
          }
        }
      }
      &-btn {
        border-radius: 0;
        width: 100%;
        margin-top: 15px;
        height: 36px;
        padding: 10px 20px;
      }
      &-des {
        text-align: center;
        font-size: 14px;
        margin-top: 15px;
      }
    }
    &-submit-btn {
      margin-top: 20px;
      width: 100%;
    }
    &-type{
        width: 178px;
        height: 40px;
        background: #FFFFFF;
        border-radius: 6px;
        border: 1px solid #DADEE2;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0,0,0,0.55);
        cursor: pointer;
        margin-top: 30px;
        img{
            width: 20px;
            height: 20px;
            margin-right: 6px;
        }
    }


  }
  iframe {
                width: 100%;
                height: 400px;
                /deep/.qrcode{
                    width: 200px !important;
                }
            }
  /deep/.el-input-group__append{
    padding: 0 !important;
  }

  </style>
  